export enum LoginProviderEnum {
  Google = 'google',
  Github = 'github',
}
